var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.1,
    d: "M10.966 20.612c7 0 10-11.85 10-14.666 0-2.814-4.48-5.086-10-5.086s-10 2.282-10 5.086c0 2.805 3 14.666 10 14.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.966 17.65v-2.321h-6.2c.68-.672 1.33-1.334 1.84-1.788 2.86-2.31 4.11-4.069 4.11-6.024 0-2.133-1.09-3.694-3.44-3.694a3.592 3.592 0 00-2.627.887 3.499 3.499 0 00-1.183 2.48c.118.456.524.78 1 .8.46 0 .95-.305 1.11-1.59l.33-1.866c.183-.046.371-.069.56-.069 1.14 0 1.84 1.106 1.84 2.884 0 1.975-.67 3.24-2.37 5.441-.72.988-1.59 2.035-2.4 3.16v1.7h7.43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.466 17.156v-2.321h-6.2c.68-.672 1.33-1.334 1.84-1.788 2.86-2.31 4.11-4.069 4.11-6.024 0-2.133-1.09-3.694-3.44-3.694a3.592 3.592 0 00-2.627.887 3.499 3.499 0 00-1.183 2.48c.118.456.524.78 1 .8.46 0 .95-.305 1.11-1.59l.33-1.866c.183-.046.371-.069.56-.069 1.14 0 1.84 1.106 1.84 2.884 0 1.975-.67 3.24-2.37 5.442-.72.987-1.59 2.034-2.4 3.16v1.699h7.43z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.966,
    x2: 0.966,
    y1: 0.86,
    y2: 20.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6FF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#315900"
  })))));
}
SvgTwo.displayName = 'Two';
export default SvgTwo;